import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  actions: {
    reserve({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/Reserves/Reserve", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    recharge({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/Recharges/Recharge", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
  },
};
